import {
  GET_PRODUCT_SUCCESS,
  PRODUCT_REQUESTING,
  LIST_PRODUCTS_SUCCESS,
  RESET_PRODUCT_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  isFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_PRODUCT_ISFETCHING: {
      return {
        ...state,
        isFetching: false
      };
    }
    case PRODUCT_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case LIST_PRODUCTS_SUCCESS: {
      const data = { ...state.data };
      action.payload.products.forEach((object) => {
        data[object.id] = object;
      });
      return {
        data,
        isFetching: false
      };
    }
    case GET_PRODUCT_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        data,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const getProductBySlug = (products, slug) => {
  if (!products.data) {
    return null;
  }
  const productIds = Object.keys(products.data);
  const productBySlugId = productIds.find(
    (id) => products.data[id].slug === slug
  );
  if (productBySlugId) {
    return products.data[productBySlugId];
  }
  return null;
};

export const getProductBySku = (products, sku) => {
  if (!products.data) {
    return null;
  }
  const productIds = Object.keys(products.data);
  const productBySkuId = productIds.find((id) => {
    const product = products.data[id];
    const foundSku = product.variants.find((variant) => variant.sku === sku);
    if (foundSku) {
      return true;
    }
    return false;
  });
  if (productBySkuId) {
    return products.data[productBySkuId];
  }
  return null;
};
